// extracted by mini-css-extract-plugin
export default {"onboardingHeader":"style_onboardingHeader__85wDn"};